export default __webpack_public_path__ + "static/media/review.c66bb79a.png";